import {
  useCallback, useState,
} from 'react';

export const useSections = <SectionType, >(initialState: Readonly<Array<SectionType>>) => {
  const [expandedSections, setExpandedSections] = useState<ReadonlyArray<SectionType>>(() => initialState);

  const expandSection = useCallback(
    (expandedSection: SectionType) =>
      setExpandedSections(alreadyExpanded => [...alreadyExpanded, expandedSection]),
    []);
  const collapseSection = useCallback((collapsedSection: SectionType) =>
    setExpandedSections(alreadyExpanded => alreadyExpanded.filter(section => section !== collapsedSection)),
  []);
  const setExpandedSection = useCallback((section: SectionType) => {
    setExpandedSections([section]);
  }, []);
  const isExpanded = useCallback((section: SectionType) => {
    return expandedSections.includes(section);
  }, [expandedSections]);

  const toggleSection = useCallback(
    (section: SectionType) => {
      if (isExpanded(section)) {
        collapseSection(section);
      }
      else {
        expandSection(section);
      }
    }, [isExpanded, collapseSection, expandSection],
  );

  return {
    setExpandedSection,
    isExpanded,
    toggleSection,
    collapseSection,
    expandSection,
  };
};
